import { render, staticRenderFns } from "./fccObservacao.vue?vue&type=template&id=8ba67970"
import script from "./fccObservacao.vue?vue&type=script&lang=js"
export * from "./fccObservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports